import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  section: {
    borderBottom: `.0631rem solid ${t.gray03}`,
  },

  select: {
    [`@media (min-width: ${t.mediaBpUpSm})`]: {
      width: '20rem',
    },
  },

  marginBottom: {
    marginBottom: '1rem',
  },
}))

export default useStyles
